import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'i',
    pathMatch: 'full',
  },
  {
    path: 'i',
    loadComponent: () => import('./core/components/insurance/insurance.component').then((m) => m.InsuranceComponent),
  },
  {
    path: '**',
    redirectTo: 'i',
    pathMatch: 'full',
  },
];
